import React from 'react';
import ReactDOM from 'react-dom';
import App from './App'; // Make sure App.js or the correct component path is used

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
